<template>
  <div class="col-lg-12" style="padding: 20px 30px">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title" v-if="this.$root.guiPerm == 'ROOT'">
          운영자 관리
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            사이트 관리 → 운영자 관리
          </div>
        </h5>
        <h5 class="card-title" v-if="this.$root.guiPerm == 'ENTERPRISE'">
          강사 관리
        </h5>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <th scope="row">T-0{{ record.id }}</th>
              <td>
                <template v-if="record.type == 'ROOT'">본사</template>
                <template v-if="record.type == 'LOCAL'">본부</template>
                <template v-if="record.type == 'ENTERPRISE'">학원</template>
                <template v-if="record.type == 'CLASS'">클래스</template>
              </td>
              <td>{{ record.username }}</td>
              <td><admin :admin="record" :ref="'admusr' + record.id" /></td>
              <!--td style="white-space: pre;">{{ record.business }}</td-->
              <td>
                <div
                  style="display: block; padding-bottom: 2px; text-align: left"
                  v-for="(bizes, bi) in record.businessDetail"
                  :key="bi"
                >
                  <!--Business v-for="biz in bizes" :key="biz.id" :biz="biz" /-->
                  <template v-for="biz in bizes" :key="biz.id">
                    {{ biz.name }}&nbsp&nbsp
                  </template>
                </div>
              </td>
              <td>{{ record.contact }}</td>
              <td>{{ record.email }}</td>
              <td>{{ record.suspended || "정상" }}</td>
              <td>
                <button
                  class="btn btn-warning btn-sm"
                  @click="this.$refs['admusr' + record.id][0].openModal()"
                >
                  수정
                </button>
                <button class="btn btn-info btn-sm" @click="sudo(record)">
                  로그인
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteUser(record)"
                >
                  삭제
                </button>
              </td>
            </tr>
          </template>
          <template #actions>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()"
              v-if="this.$root.guiPerm == 'ROOT'"
            >
              관리자 등록
            </button>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()"
              v-if="this.$root.guiPerm == 'ENTERPRISE'"
            >
              강사 등록
            </button>
          </template>
        </query-grid>

        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          id="adminModal"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  id="exampleModalLongTitle"
                  v-if="this.$root.guiPerm == 'ROOT'"
                >
                  관리자 등록
                </h5>
                <h5
                  class="modal-title"
                  id="exampleModalLongTitle"
                  v-if="this.$root.guiPerm == 'ENTERPRISE'"
                >
                  강사 등록
                </h5>
              </div>
              <div class="modal-body">
                <i class="fas fa-check-circle"></i> 필수입력

                <table class="table">
                  <colgroup>
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td style="text-align: center">자동생성</td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>사용여부
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select
                              class="custom-select flex_center"
                              id="inputGroupSelect01"
                            >
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">관리범위</td>
                      <td colspan="3" style="text-align: center">
                        <template v-if="this.$root.guiPerm == 'ROOT'">
                          <tree-btn :tree="this.$refs.manageRange" />
                        </template>
                        <template v-else>
                          <tree-btn :tree="this.$refs.biz" />
                        </template>
                      </td>
                    </tr>

                    <!--tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>로그인 허용 시작일</td>
                      <td>


                        <input type="date" class="hidtype" :value="changedData.startDate || selData.startDate"
                          :class="{'hidtype-changed': changedData.startDate}"
                          @input="doChange('startDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.startDate"
                          @click="delete changedData.startDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>로그인 허용 종료일</td>
                      <td>
                        <input type="date" class="hidtype" :value="changedData.endDate || selData.endDate"
                          :class="{'hidtype-changed': changedData.endDate}"
                          @input="doChange('endDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.endDate"
                          @click="delete changedData.endDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                    </tr-->
                  </tbody>
                </table>

                <table class="table">
                  <colgroup>
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                    <col style="width: 25%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="th_bg">
                        <span v-if="this.$root.guiPerm == 'ENTERPRISE'"
                          ><i class="fas fa-check-circle"></i>강사 아이디</span
                        >
                        <span v-if="this.$root.guiPerm == 'ROOT'">아이디</span>
                      </td>

                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.username || selData.username"
                          :class="{ 'hidtype-changed': changedData.username }"
                          @input="doChange('username', $event.target.value)"
                          placeholder="아이디"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.username"
                          @click="delete changedData.username"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>비밀번호
                      </td>
                      <td>
                        <input
                          type="password"
                          class="hidtype"
                          :value="changedData.password || selData.password"
                          :class="{ 'hidtype-changed': changedData.password }"
                          @input="doChange('password', $event.target.value)"
                          placeholder="비밀번호"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.password"
                          @click="delete changedData.password"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.contact || selData.contact"
                          :class="{ 'hidtype-changed': changedData.contact }"
                          @input="doChange('contact', $event.target.value)"
                          placeholder="연락처"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.contact"
                          @click="delete changedData.contact"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <td class="th_bg">이메일</td>
                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.email || selData.email"
                          :class="{ 'hidtype-changed': changedData.email }"
                          @input="doChange('email', $event.target.value)"
                          placeholder="이메일"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.email"
                          @click="delete changedData.email"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">
                        <span v-if="this.$root.guiPerm == 'ENTERPRISE'"
                          ><i class="fas fa-check-circle"></i>강사 이름</span
                        >
                        <span v-if="this.$root.guiPerm == 'ROOT'"
                          ><i class="fas fa-check-circle"></i>이름</span
                        >
                      </td>
                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.name || selData.name"
                          :class="{ 'hidtype-changed': changedData.name }"
                          @input="doChange('name', $event.target.value)"
                          placeholder="아이디"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.name"
                          @click="delete changedData.name"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>영문명
                      </td>
                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.engName || selData.engName"
                          :class="{ 'hidtype-changed': changedData.engName }"
                          @input="doChange('engName', $event.target.value)"
                          placeholder="아이디"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.engName"
                          @click="delete changedData.engName"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer flex_center">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="doSend()"
                  v-if="this.$root.guiPerm == 'ENTERPRISE'"
                >
                  강사 등록
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="doSend()"
                  v-if="this.$root.guiPerm == 'ROOT'"
                >
                  관리자 등록
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    multiple
    render-button
    :callback="selectedBiz"
    selected
    :selectedNodeIds="this.selData.bizIds"
    ref="manageRange"
  />
  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    multiple
    render-button
    :callback="selectedBiz"
    :selectedNodeIds="this.selData.bizIds"
    ref="biz"
  />
</template>

<style>
.hidtype {
  border: 0;
  text-align: center;
}

.hidtype-error {
  color: red;
}

.hidtype-changed {
  color: goldenrod;
}
</style>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import VueCookies from "vue-cookies";
import axios from "axios";
import TreeBtn from "../components/treeBtn.vue";
import Admin from "../components/detail_pages/Admin.vue";
export default {
  name: "Home",
  components: {
    Tree,
    Business,
    TreeBtn,
    QueryGrid,
    Admin,
  },
  mounted() {
    if (this.$route.query.type) {
      this.$refs.qg.pushSetting("filter_type_ROOT", false);
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", false);
      this.$refs.qg.pushSetting("filter_type_LOCAL", false);
      this.$refs.qg.pushSetting("filter_type_CLASS", false);
      this.$refs.qg.pushSetting("filter_type_" + this.$route.query.type, true);
    } else if (this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("filter_type_ROOT", false);
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
      this.$refs.qg.pushSetting("filter_type_LOCAL", false);
      this.$refs.qg.pushSetting("filter_type_CLASS", true);
    } else {
      this.$refs.qg.pushSetting("filter_type_ROOT", true);
      this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
      this.$refs.qg.pushSetting("filter_type_LOCAL", true);
      this.$refs.qg.pushSetting("filter_type_CLASS", false);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query,
      function (toQuery, previousQuery) {
        // react to route changes...
        console.log("route query has been changed");
        console.log(toQuery);
        if (JSON.stringify(toQuery) == JSON.stringify(previousQuery)) return;
        if (toQuery.type) {
          this.$refs.qg.pushSetting("filter_type_ROOT", false);
          this.$refs.qg.pushSetting("filter_type_ENTERPRISE", false);
          this.$refs.qg.pushSetting("filter_type_LOCAL", false);
          this.$refs.qg.pushSetting("filter_type_CLASS", false);
          this.$refs.qg.pushSetting("filter_type_" + toQuery.type, true);
        } else if (this.$root.guiPerm == "ENTERPRISE") {
          this.$refs.qg.pushSetting("filter_type_ROOT", false);
          this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
          this.$refs.qg.pushSetting("filter_type_LOCAL", false);
          this.$refs.qg.pushSetting("filter_type_CLASS", true);
        } else {
          this.$refs.qg.pushSetting("filter_type_ROOT", true);
          this.$refs.qg.pushSetting("filter_type_ENTERPRISE", true);
          this.$refs.qg.pushSetting("filter_type_LOCAL", true);
          this.$refs.qg.pushSetting("filter_type_CLASS", false);
        }

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    sudo(biz) {
      let form = new FormData();
      form.append("grant_type", "existing_session");
      form.append("id", biz.id);
      axios
        .post("/oauth/login", form)
        .then((response) => {
          return new Promise((resolve) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "로그인할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              VueCookies.set("access_token", response.data.access_token);
              VueCookies.set("refresh_token", response.data.refresh_token);
              $.notify(
                {
                  // options
                  message: "권한 변경하여 로그인 되었습니다.",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              this.$root.is_logged_in = true;
              resolve(response.data);
            }
          });
        })
        .then(() => {
          this.$root.getBusinesses();
        });
    },
    deleteUser(user) {
      if (!confirm("정말로 삭제할까요")) return;
      axios.delete("/admins/" + user.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "삭제할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "삭제되었습니다.",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          resolve(response.data);
        }
      });
    },
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz) {
      this.selBiz = biz;
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
          grant: this.selBiz.join(","),
        };
      } else {
        data = this.changedData;
      }

      var send = {
        method: this.creating ? "post" : "patch",
        url: "/admins" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      };

      if(!this.selBiz.length){
          //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
          $.notify({
            // options
            message: '최소 1개 이상의 관리범위를 지정하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
      }

      if (this.creating) {
        axios(send).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "처리할 수 없습니다 " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            // 201 created 응답이 오면 계정 생성
            axios
              .post("/admins/" + response.data.id + "/grants", {
                grant: this.selBiz.join(","),
              })
              .then((response2) => {
                if (response2.data.error) {
                  $.notify(
                    {
                      // options
                      message: "처리할 수 없습니다 " + response2.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  // 마지막으로 grant

                  bootstrap.Modal.getInstance(
                    document.getElementById("adminModal")
                  ).hide();
                  $.notify(
                    {
                      // options
                      message: "처리되었습니다",
                    },
                    {
                      // settings
                      type: "success",
                      z_index: 9999,
                    }
                  );
                  this.$refs.qg.search();
                }
              });
          }
        });
      } else {
        if (this.selBiz.length) {
          axios
            .post("/admins/" + this.selData.id + "/grants", {
              grant: this.selBiz.join(","),
            })
            .then((response2) => {
              if (response2.data.error) {
                $.notify(
                  {
                    // options
                    message: "처리할 수 없습니다 " + response2.data.error,
                  },
                  {
                    // settings
                    type: "danger",
                    z_index: 9999,
                  }
                );
              } else {
                // 마지막으로 grant

                bootstrap.Modal.getInstance(
                  document.getElementById("adminModal")
                ).hide();
                $.notify(
                  {
                    // options
                    message: "처리되었습니다",
                  },
                  {
                    // settings
                    type: "success",
                    z_index: 9999,
                  }
                );
                this.$refs.qg.search();
              }
            });
        }
        if (Object.keys(this.changedData).length) {
          axios(send).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "처리할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              bootstrap.Modal.getInstance(
                document.getElementById("adminModal")
              ).hide();
              $.notify(
                {
                  // options
                  message: "처리되었습니다",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              this.$refs.qg.search();
            }
          });
        }
      }
    },
    creatingMode() {
      this.selData = {
        username: "",
        password: "",
        name: "",
        engName: "",
        contact: "",
        email: "",
        startDate: "",
        endDate: "",
      };
      this.$refs.manageRange.reset([]);
      this.changedData = {};
      this.creating = true;
    },
    modifyMode(record) {
      this.creating = false;
      this.changedData = {};
      this.selData = {
        id: record.id,
        username: record.username,
        password: "****",
        name: record.name,
        engName: record.engName,
        contact: record.contact,
        email: record.email,
        startDate: record.startDate.split(" ")[0],
        endDate: record.endDate.split(" ")[0],
        bizIds: record.bizIds,
      };
      this.$refs.manageRange.reset(record.bizIds.split(", "));
    },
  },
  data() {
    return {
      records: [],
      selBiz: [],
      creating: true,
      selData: {
        username: "",
        password: "",
        name: "",
        engName: "",
        contact: "",
        email: "",
        startDate: "",
        endDate: "",
      },
      changedData: {},
      searchBiz: {},
      searchKeyword: "",
      config: {
        name: "관리계정",
        req_endpoint: "/admins",
        default_limit: 20,
        disable_init_search: true,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "filter_type",
            name: "소속유형",
            type: "switch",
            filter_type: {
              ROOT: "본사",
              LOCAL: "본부",
              ENTERPRISE: "학원",
              CLASS: "클래스",
            },
          },
          {
            id: "status_filter",
            name: "상태",
            type: "switch",
            filter_type: {
              ACTIVE: "사용",
              SUSPENDED: "미사용",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "이름/아이디로 검색",
          },
          {
            id: "date",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "생성일",
              start_date: "시작일",
              end_date: "종료일",
            },
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "type",
            sortable: true,
            name: "소속타입",
            excel_print: (v) => {
              var a = {
                ROOT: "본사",
                LOCAL: "본부",
                ENTERPRISE: "학원",
                CLASS: "클래스",
              };
              return a[v.type];
            },
          },

          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "name",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },

          {
            id: "parent",
            name: "상위기관",
            excel_print: (v) => {
              return v.business;
            },
          },
          {
            id: "contact",
            name: "연락처",
            excel_print: (v) => {
              return v.contact || "";
            },
          },
          {
            id: "email",
            name: "이메일",
            excel_print: (v) => {
              return v.email || "";
            },
          },
          {
            id: "status",
            sortable: true,
            name: "상태",
            excel_print: (v) => {
              return v.suspended ? "미사용" : "사용";
            },
          },
          {
            id: "action",
            name: "작업",
          },
        ],
      },
    };
  },
};
</script>
